interface BreezyLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  showText?: boolean
}

export default function BreezyLogo({ size = 'md', showText = true }: BreezyLogoProps) {
  const sizes = {
    sm: { icon: 32, text: 'text-lg', sub: 'text-xs' },
    md: { icon: 48, text: 'text-2xl', sub: 'text-sm' },
    lg: { icon: 80, text: 'text-4xl', sub: 'text-base' },
    xl: { icon: 120, text: 'text-5xl', sub: 'text-lg' }
  }

  const s = sizes[size]

  return (
    <div className="flex items-center gap-4">
      {/* Logo Image */}
      <img
        src="/logo.png"
        alt="BreezyDoc Logo"
        style={{
          width: s.icon,
          height: s.icon,
          filter: 'drop-shadow(0 0 20px rgba(59, 130, 246, 0.5)) drop-shadow(0 0 40px rgba(139, 92, 246, 0.3))'
        }}
      />

      {/* Text */}
      {showText && (
        <div>
          <h1
            className={`${s.text} font-bold tracking-tight`}
            style={{
              background: 'linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #22d3ee 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              filter: 'drop-shadow(0 0 20px rgba(96, 165, 250, 0.3))'
            }}
          >
            BreezyDoc
          </h1>
          <p
            className={`${s.sub} font-medium tracking-widest uppercase`}
            style={{ color: 'rgba(148, 163, 184, 0.8)' }}
          >
            by Coretek
          </p>
        </div>
      )}
    </div>
  )
}
